import { z } from 'zod';

import { CourtLayout } from './court-layout';
import { thresholdsSchema } from './thresholds';

export type TeamSettings = z.output<typeof teamSettingsSchema>;
export type TeamSettingsDTO = z.input<typeof teamSettingsSchema>;

export const teamSettingsSchema = z.object({
  courtLayout: z.enum(CourtLayout).catch(CourtLayout.NCAA),
  courtDimensions: z
    .object({
      width: z.number().positive().nullable().catch(null),
      length: z.number().positive().nullable().catch(null),
    })
    .catch({
      width: null,
      length: null,
    }),
  thresholds: thresholdsSchema.catch({
    shotLoadHigh: 3.5,
    shotLoadLow: 2,
  }),
  rpeQuestionIds: z.array(z.string()).catch([]),
});
